import { call, put } from 'redux-saga/effects';
import reduceCRMWebConfiguration from '../../actions/CRMWebConfiguration/reduceCRMWebConfiguration';

export default function* getCRMWebConfigurationSaga() {
    const response = yield call(fetch, '/api/context/crm-web-configuration');
    const configuration = yield call([response, 'json']);
    yield put(reduceCRMWebConfiguration({ ...configuration.crmWebConfiguration }));
    return;
}
